type SortOrder = 'asc' | 'desc';

function sortObjectsByDate<T>(objects: T[], dateField: keyof T, order: SortOrder = 'asc'): T[] {
  return objects.slice().sort((a, b) => {
    const dateA = new Date(String(a[dateField]));
    const dateB = new Date(String(b[dateField]));

    // Si la date est invalide, elle est remplacée par la date epoch (0)
    const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
    const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();

    // Tri par ordre croissant ou décroissant
    if (order === 'asc') {
      return timeA - timeB;
    } else {
      return timeB - timeA;
    }
  });
}

export default sortObjectsByDate;
